export default __webpack_public_path__ + "static/media/HedvigLettersSans-Regular.e058369d.ttf";